import React, {useContext, useState} from "react";
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent,
    Grid, Stack, Typography, useTheme } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import {ExpandMore} from "@mui/icons-material";
import {useLocation, useNavigate } from "react-router-dom";
import {useRecoilState} from "recoil";
import {useTranslation} from "react-i18next";
import GeneralInfo from "./GeneralInfo/GeneralInfo";
import AdditionalInfo from "./AdditionalInfo/AdditionalInfo";
import {generalInfoState} from "../../../../search-repair-shop/state";
import EParking from "./EParking/EParking";
import RepresentativeInfo from "./RepresentativeInfo/RepresentativeInfo";
import FinancialInfo from "./FinancialInfo/FinancialInfo";
import {SET_SNACKBAR} from "../../../../common/utils";
import {GlobalContext} from "../../../../../../util/state/GlobalContextProvider";
import {checkInfoActivation} from "../../../RsDetail.actions";
import CustomLoader from "../../../../../../util/component/CustomLoader";
import {setSnackbar} from "../../../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../../../util/state/globalVariables";

const InfoTab = () => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();
    const location = useLocation();
    const [generalInfo, setGeneralInfo] = useRecoilState(generalInfoState);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const navigate = useNavigate();
    const getLastItem = (path:any) => path.substring(path.lastIndexOf('/') + 1)
    let idOnReload = getLastItem(location.pathname);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isActivated, setIsActivated] = useState(generalInfo?.currentStatus === "ACTIVATED");
    const handleAccordionOnChange = (e: React.SyntheticEvent) => {
        e.stopPropagation();
    }
    const reqParameters = {id: generalInfo?.id}
    const handleActivation = () => {
        setIsLoading(true);
        checkInfoActivation(reqParameters)
            .then( (res:any) => {
                setIsActivated(true);
                handleClose();
                setIsLoading(false);
                setGeneralInfo(Object.assign({}, generalInfo, res));
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('searchRs.messages.activationOk'),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true,
                        },
                    },
                });
            })
            .catch((err: any) => {
                handleClose();
                setIsLoading(false);
                dispatchGlobalData(SET_SNACKBAR.ERROR);
            });
    }

    const routeChange = () => {
        let path = `/mobility-store/activation-setup-panel`;
        if (generalInfo?.id !== undefined) {
            navigate(path, {
                state: {
                    msId: generalInfo?.id
                }
            });
        } else {
            navigate(path, {
                state: {
                    msId: parseInt(idOnReload)
                }
            });
        }
    }

    return (
        <>
            <Accordion onChange={(e) => handleAccordionOnChange(e)}>
                <AccordionSummary expandIcon={<ExpandMore/>}>
                    <Typography variant="h6">
                        {t("rsDetail.tabInfo.title")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <GeneralInfo/>
                </AccordionDetails>
            </Accordion>

            <Accordion onChange={(e) => handleAccordionOnChange(e)}>
                <AccordionSummary expandIcon={<ExpandMore/>}>
                    <Typography variant="h6">
                        {t("rsDetail.tabInfo.accordion.additional")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AdditionalInfo/>
                </AccordionDetails>
            </Accordion>

            <Accordion onChange={(e) => handleAccordionOnChange(e)}>
                <AccordionSummary expandIcon={<ExpandMore/>}>
                    <Typography variant="h6">
                        {t("rsDetail.tabInfo.accordion.eParking")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <EParking/>
                </AccordionDetails>
            </Accordion>

            <Accordion onChange={(e) => handleAccordionOnChange(e)}>
                <AccordionSummary expandIcon={<ExpandMore/>}>
                    <Typography variant="h6">
                        {t("rsDetail.tabInfo.accordion.representative")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <RepresentativeInfo/>
                </AccordionDetails>
            </Accordion>

            <Accordion onChange={(e) => handleAccordionOnChange(e)}>
                <AccordionSummary expandIcon={<ExpandMore/>}>
                    <Typography variant="h6">
                        {t("rsDetail.tabInfo.accordion.financial")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FinancialInfo/>
                </AccordionDetails>
            </Accordion>

            <Grid xs={12}>
                <Stack direction="row" sx={{my: theme.spacing(2), mt: theme.spacing(2)}} justifyContent="flex-end" alignItems="flex-end">
                    {(generalInfo?.currentStatus === "ACTIVATED" || isActivated) && (
                        <Button variant="contained"  sx={{ml: theme.spacing(2)}} onClick={routeChange} >
                            {t("rsDetail.tabInfo.button.gotoConfigPanel")}
                        </Button>
                    )}
                    {(generalInfo?.currentStatus === "REGISTERED" && !isActivated) && (
                        <Button variant="contained" onClick={handleOpen} >
                            {t("rsDetail.tabInfo.button.activate")}
                        </Button>
                    )}
                </Stack>
            </Grid>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t("rsDetail.dialog.title")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("rsDetail.dialog.content")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant={"outlined"} color={"accent"}>
                        {t("rsDetail.dialog.action.cancel")}
                    </Button>
                    <Button autoFocus onClick={handleActivation}>
                        {t("rsDetail.dialog.action.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
            <CustomLoader loading={isLoading} />
        </>
    )
}

export default InfoTab;
